import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { StarField } from "@/components/StarField";
import { Logo } from "@/components/Logo";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const { data: bp } = await api.get("/birth-profile");
        nav(bp?.date_of_birth && bp?.birth_city ? "/dashboard" : "/onboarding", { replace: true });
      } catch {
        setErr(true);
        setTimeout(() => nav("/login", { replace: true }), 1800);
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#080B1A] flex items-center justify-center relative overflow-hidden">
      <StarField count={50} />
      <div className="relative z-10 text-center">
        <Logo className="justify-center" />
        <div className="mt-6 flex items-center justify-center gap-3 text-slate-300">
          {err ? (
            <span className="text-red-400 text-sm">Sign-in failed. Redirecting…</span>
          ) : (
            <>
              <Loader2 className="animate-spin text-amber-400" size={20} />
              <span className="text-sm">Signing you in securely…</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
